import classNames from "classnames";
import * as React from "react";
import { Avatar } from "../avatar";
import { KEY_VALUES } from "../utils";
var FeedsCommentItem = function FeedsCommentItem(props) {
  var _item$images;
  var item = props.item,
    onLikeStatusChange = props.onLikeStatusChange,
    onCommentClick = props.onCommentClick,
    onPreviewImage = props.onPreviewImage,
    shortNameTpl = props.shortNameTpl,
    headerTpl = props.headerTpl,
    bodyTpl = props.bodyTpl,
    footerTpl = props.footerTpl;
  var backBoxElement = null;
  var switchLikeStatus = function switchLikeStatus(item) {
    onLikeStatusChange === null || onLikeStatusChange === void 0 ? void 0 : onLikeStatusChange(item);
  };
  var showComments = function showComments(item) {
    onCommentClick === null || onCommentClick === void 0 ? void 0 : onCommentClick(item);
  };
  var onCommentsKeydown = function onCommentsKeydown(event, type, item) {
    if (event.key === KEY_VALUES.ENTER || event.key === KEY_VALUES.SPACE) {
      event.preventDefault();
      if (type === 'like') switchLikeStatus(item);else if (type === 'comment') showComments(item);
    }
  };
  var zoomInImage = function zoomInImage() {
    backBoxElement = document.body.getElementsByClassName('shadowDiv')[0];
    var bigImg = document.body.getElementsByClassName('imgCur')[0];
    backBoxElement.classList.add('backBox');
    backBoxElement.style.display = 'block';
    bigImg.classList.add('bigImg');
    document.body.classList.add('none-scroll');
    document.addEventListener('keydown', hideShadow);
    backBoxElement.onclick = function (event) {
      event.preventDefault();
      if (event.target != bigImg) {
        backBoxElement.style.display = 'none';
        document.removeEventListener('keydown', hideShadow);
        backBoxElement = null;
        onPreviewImage === null || onPreviewImage === void 0 ? void 0 : onPreviewImage(false);
      }
    };
  };
  var hideShadow = function hideShadow(event) {
    event.preventDefault();
    if (event.key === KEY_VALUES.ESC && backBoxElement) {
      backBoxElement.style.display = 'none';
      document.removeEventListener('keydown', hideShadow);
      backBoxElement = null;
      onPreviewImage === null || onPreviewImage === void 0 ? void 0 : onPreviewImage(false);
    }
  };
  var showImage = function showImage(imgSrc) {
    var backBox = document.createElement('div');
    backBox.classList.add('shadowDiv');
    backBox.style.display = 'none';
    var bigImg = document.createElement('img');
    bigImg.classList.add('imgCur');
    bigImg.src = imgSrc;
    backBox.appendChild(bigImg);
    document.body.appendChild(backBox);
    zoomInImage();
    onPreviewImage === null || onPreviewImage === void 0 ? void 0 : onPreviewImage(true);
  };
  var handleKeyDown = function handleKeyDown(event, img) {
    if (event.key === KEY_VALUES.ENTER) {
      showImage(img);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "comments"
  }, /*#__PURE__*/React.createElement("div", {
    className: "comments-short-name"
  }, item.shortName && /*#__PURE__*/React.createElement(Avatar, {
    label: item.shortName,
    bgColor: item.shortNameBgColor
  }), shortNameTpl === null || shortNameTpl === void 0 ? void 0 : shortNameTpl()), /*#__PURE__*/React.createElement("div", {
    className: "comments-detail"
  }, /*#__PURE__*/React.createElement("div", {
    className: "comments-info"
  }, item.fullName && /*#__PURE__*/React.createElement("div", {
    className: "comments-name"
  }, item.fullName), item.commentsTime && /*#__PURE__*/React.createElement("div", {
    className: "comments-time"
  }, item.commentsTime), headerTpl === null || headerTpl === void 0 ? void 0 : headerTpl()), /*#__PURE__*/React.createElement("div", {
    className: "comments-content"
  }, item.commentsContent), /*#__PURE__*/React.createElement("div", {
    className: "comments-images"
  }, (item === null || item === void 0 ? void 0 : (_item$images = item.images) === null || _item$images === void 0 ? void 0 : _item$images.length) && item.images.map(function (img, imgIndex) {
    return /*#__PURE__*/React.createElement("div", {
      className: "image",
      key: imgIndex,
      tabIndex: 0,
      onDoubleClick: function onDoubleClick(e) {
        showImage(img);
      },
      onKeyDown: function onKeyDown(e) {
        handleKeyDown(e, img);
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: img,
      alt: "comment image " + imgIndex + 1
    }));
  }), bodyTpl === null || bodyTpl === void 0 ? void 0 : bodyTpl()), /*#__PURE__*/React.createElement("div", {
    className: "comments-likes"
  }, item.likesCount && /*#__PURE__*/React.createElement("div", {
    className: "comments-action comments-action-like",
    role: "button",
    tabIndex: 0,
    "aria-label": item.likesCount + ' likes',
    onClick: function onClick(e) {
      return switchLikeStatus(item);
    },
    onKeyDown: function onKeyDown(e) {
      return onCommentsKeydown(e, 'like', item);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames("Appkit4-icon", {
      "icon-thumb-up-outline": !item.liked,
      "icon-thumb-up-fill": item.liked
    }),
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("span", {
    className: "comments-action-text"
  }, item.likesCount, " likes")), item.commentsCount && /*#__PURE__*/React.createElement("div", {
    className: "comments-action  comments-action-comment",
    role: "button",
    tabIndex: 0,
    onClick: function onClick(e) {
      return showComments(item);
    },
    onKeyDown: function onKeyDown(e) {
      return onCommentsKeydown(e, 'comment', item);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "Appkit4-icon icon-comment-outline",
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("span", {
    className: "comments-action-text"
  }, item.commentsCount, " comments")), footerTpl === null || footerTpl === void 0 ? void 0 : footerTpl())));
};
export default FeedsCommentItem;